import { render, staticRenderFns } from "./VlShowInspectionModal.vue?vue&type=template&id=f067bc3c&scoped=true&"
import script from "./VlShowInspectionModal.vue?vue&type=script&lang=js&"
export * from "./VlShowInspectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f067bc3c",
  null
  
)

export default component.exports